import axiosClient from './axiosClient';
export default {
  getAll: (params) => axiosClient.get('/tipicontratto', { params }),
  getAllPublic: (params) => axiosClient.get('/tipicontrattopublic', { params }),
  get: (id) => axiosClient.get(`/tipicontratto/${id}`),
  create: (data) => axiosClient.post('/tipicontratto', data),
  update: (id, data) => axiosClient.put(`/tipicontratto/${id}`, data),
  delete: (id) => axiosClient.delete(`/tipicontratto/${id}`),
};